import React, { Component } from "react";
import "../flightplan/css/flightplan.css";
import LoadingScreen from "react-loading-screen";
// import avion from "../../assets/images/Spinner/avion.gif";
import close from "../../assets/logo/close.svg";
import { Link } from "react-router-dom";
import Modal from "react-awesome-modal";

var noScroll = require("no-scroll");

export default class vision extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modalIsShow: false,
			modalIsShowIdiomas: false,
			loading: false,
			error: null,
			entries: null,
			visible: false
		};

		this.escFunction = this.escFunction.bind(this);
		this.setWrapperRef = this.setWrapperRef.bind(this);
	}

	componentDidMount() {
		setTimeout(() => this.setState({ loading: false }), 1500);
		document.addEventListener("keydown", this.escFunction, false);
	}

	UNSAFE_componentWillMount() {
		document.addEventListener("mousedown", this.handleClick, false);
	}
	escFunction(event) {
		if (event.keyCode === 27) {
			this.setState({
				modalIsShow: false,
				modalIsShowIdiomas: false,
				visible: false
			});
		}
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.escFunction, false);
		document.removeEventListener("mousedown", this.handleClick, false);
	}
	handleClick = e => {
		if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
			this.setState({
				modalIsShow: false,
				modalIsShowIdiomas: false
			});
		}
	};
	setWrapperRef(node) {
		this.wrapperRef = node;
	}

	showAlertModal = () => {
		this.setState({
			modalIsShow: !this.state.modalIsShow
		});
	};

	showAlertModal01 = () => {
		this.setState({
			modalIsShowIdiomas: !this.state.modalIsShowIdiomas
		});
	};

	openModal() {
		this.setState({
			visible: true
		});
		noScroll.on();
	}

	closeModal() {
		this.setState({
			visible: false
		});
		noScroll.off();
	}

	render() {
		const { loading } = this.state;
		return (
			<LoadingScreen
				loading={loading}
				bgColor="#f5f5f5"
				spinnerColor="#007dc3"
				textColor="#0b2343"
				//logoSrc={avion}
				text="あなたの経験をロードする"
			>
				<div>
					{this.state.modalIsShow === true ? (
						<div className="flightVideoModal">
							<div
								className="videoModalWindow"
								ref={this.setWrapperRef}
							>
								<div
									className="closeModal"
									onClick={this.showAlertModal}
								>
									<img src={close} alt="cerrar"></img>
								</div>
								<iframe
									title="JAP MODAL FLIGHTPLAN"
									width="100%"
									height="100%"
									src="https://www.youtube.com/embed/5mt3FdPdUT0"
									frameborder="0"
									allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen
								></iframe>
							</div>
						</div>
					) : (
						""
					)}

					<Modal
						visible={this.state.visible}
						width="auto"
						height="auto"
						effect="fadeInDown"
						onClickAway={() => this.closeModal()}
						className="container-modal-notification"
					>
						<div className="selectLangugeModal">
							<div className="whiteModal">
								<div
									className="closeModal"
									onClick={() => this.closeModal()}
								>
									<img src={close} alt="cerrar"></img>
								</div>

								<div className="padding">
									<h4>Selecciona un idioma</h4>
									<div className="gridFlags">
										<Link
											className="contFlag"
											to="/nosotros/plan-de-vuelo"
										>
											<div className="flags spanish"></div>
											<p>Español</p>
										</Link>

										<Link
											className="contFlag"
											to="/nosotros/plan-de-vuelo/ingles"
										>
											<div className="flags english"></div>
											<p>Inglés</p>
										</Link>

										<Link
											className="contFlag"
											to="/nosotros/plan-de-vuelo/frances"
										>
											<div className="flags french"></div>
											<p>Francés</p>
										</Link>

										<Link
											className="contFlag"
											to="/nosotros/plan-de-vuelo/holandes"
										>
											<div className="flags dutch"></div>
											<p>Holandés</p>
										</Link>

										<Link
											className="contFlag"
											to="/nosotros/plan-de-vuelo/portugues"
										>
											<div className="flags portuguese"></div>
											<p>Portugués</p>
										</Link>

										<Link
											className="contFlag"
											to="/nosotros/plan-de-vuelo/chino"
										>
											<div className="flags mandarin"></div>
											<p>Mandarín</p>
										</Link>

										<Link
											className="contFlag"
											to="/nosotros/plan-de-vuelo/coreano"
										>
											<div className="flags korean"></div>
											<p>Coreano</p>
										</Link>

										<Link
											className="contFlag"
											to="/nosotros/plan-de-vuelo/japones"
										>
											<div className="flags japan"></div>
											<p>Japonés</p>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</Modal>

					<div className="flightplanWrapper">
						<div className="midflightplan">
							<h1>
								2019<br></br>年のフライトプラン
							</h1>

							<a
								className="download"
								href="https://grupoaeromexico-my.sharepoint.com/:b:/g/personal/amcomunicacioninterna_aeromexico_com/EdBg9i_By-FKqjS9y8IFs-ABd5gBhfCHyevBQ90C6LMjKw?e=3FlUmL"
								target="_blank"
								rel="noopener noreferrer"
							>
								<p>ダウンロード</p>
							</a>

							<div className="linenamebottom"></div>

							{/*<div className="downloadFlightPlan">
                <div className="downloadIcon"></div>
                <div className="textdownload">
                  <h6>Plan de Vuelo 2019</h6>
                  <p>Descarga el Plan de Vuelo completo </p>
                </div>
          </div>*/}

							<div
								className="languageFlightPlan"
								onClick={() => this.openModal()}
							>
								<p>日本人</p>
								<div className="languageFlag japan"></div>
							</div>

							<div className="circlePlaneFlight">
								<h4 className="title color01">安全と保安</h4>
								<p className="securityFirst">
									<span></span>常に安全第一
								</p>

								<h4 className="title color02">従業員の経験</h4>
								<p className="employeeExperience">
									<span></span>
									当社の価値観に則った生活に根差した、品位ある
									ふるまい
								</p>

								<h4 className="title color03">お客様の体験</h4>
								<p className="cutomerExperience">
									<span></span>
									質の高いサービスの提供とお客様の視点からのプログラム導入
								</p>

								<h4 className="title color04">効率性の創出</h4>
								<p className="crearEficiencia">
									<span></span>
									一定の財務業績の提供と生産性の強化
								</p>

								<h4 className="title color05">完璧に遂行</h4>
								<p className="ejecucionImpecable">
									<span></span>
									継続的改善の精神を備え、産業として最良の運営
								</p>

								<div className="planeitem"></div>
								<div className="planebg planebgjapan"></div>
							</div>
						</div>
					</div>
				</div>
			</LoadingScreen>
		);
	}
}
